<template>
  <section class="trustbar" aria-label="Waarom Plug2Charge">
    <div class="max-w-screen-xl mx-auto px-6">
      <ul class="trustbar-list" role="list">

        <li class="trustbar-item">
          <div class="trustbar-icon-wrap" aria-hidden="true">
            <i class="bi bi-truck"></i>
          </div>
          <div class="trustbar-text">
            <strong>Gratis verzending</strong>
            <span>Vanaf €50, volgende dag</span>
          </div>
        </li>

        <li class="trustbar-divider" aria-hidden="true"></li>

        <li class="trustbar-item">
          <div class="trustbar-icon-wrap" aria-hidden="true">
            <i class="bi bi-shield-check"></i>
          </div>
          <div class="trustbar-text">
            <strong>2 jaar garantie</strong>
            <span>Standaard op elk product</span>
          </div>
        </li>

        <li class="trustbar-divider" aria-hidden="true"></li>

        <li class="trustbar-item">
          <div class="trustbar-icon-wrap" aria-hidden="true">
            <i class="bi bi-arrow-clockwise"></i>
          </div>
          <div class="trustbar-text">
            <strong>30 dagen retour</strong>
            <span>Niet goed, geld terug</span>
          </div>
        </li>

        <li class="trustbar-divider" aria-hidden="true"></li>

        <li class="trustbar-item">
          <div class="trustbar-icon-wrap trustbar-icon-star" aria-hidden="true">
            <i class="bi bi-star-fill"></i>
          </div>
          <div class="trustbar-text">
            <strong>4,9/5 sterren</strong>
            <span>Op 380+ reviews</span>
          </div>
        </li>

      </ul>
    </div>
  </section>
</template>

<style scoped>
.trustbar {
  background: #fff;
  border-top: 3px solid #FFD500;
  border-bottom: 1px solid #efefef;
  padding: 0;
}

.trustbar-list {
  display: flex;
  align-items: stretch;
  list-style: none;
  padding: 0;
  margin: 0;
}

.trustbar-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.9rem 1.5rem;
  flex: 1;
  min-width: 0;
}

.trustbar-divider {
  width: 1px;
  background: #efefef;
  margin: 0.75rem 0;
  flex-shrink: 0;
}

.trustbar-icon-wrap {
  width: 34px;
  height: 34px;
  background: #fffbeb;
  border: 1px solid #f4e9b8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  color: #7a5f00;
  flex-shrink: 0;
}

.trustbar-icon-star i { color: #f0a800; }

.trustbar-text {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.trustbar-text strong {
  font-size: 0.875rem;
  font-weight: 800;
  color: #111;
  white-space: nowrap;
}

.trustbar-text span {
  font-size: 0.78rem;
  color: #666;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .trustbar-list { flex-wrap: wrap; }
  .trustbar-item {
    flex: 1 1 calc(50% - 1px);
    min-width: 0;
    padding: 0.875rem 1rem;
  }
  .trustbar-divider:nth-child(4) { display: none; }
  .trustbar-divider { margin: 0.5rem 0; }
}

@media (max-width: 380px) {
  .trustbar-item { flex: 1 1 100%; }
  .trustbar-divider { width: 100%; height: 1px; margin: 0; }
}
</style>
